function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.2971 2.79834H2.85903C2.1611 2.79834 1.59424 3.3652 1.59424 4.06313V14.7352C1.59424 15.4332 2.1611 16 2.85903 16H10.2971C10.995 16 11.5619 15.4332 11.5619 14.7352V4.06313C11.5586 3.3652 10.9917 2.79834 10.2971 2.79834ZM10.6739 14.732C10.6739 14.9417 10.5035 15.1121 10.2938 15.1121H2.85576C2.64605 15.1121 2.47566 14.9417 2.47566 14.732V4.06313C2.47566 3.85343 2.64605 3.68304 2.85576 3.68304H10.2938C10.5035 3.68304 10.6739 3.85343 10.6739 4.06313V14.732Z",
  fill: "currentColor"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.1413 0H5.70327C5.00534 0 4.43848 0.566865 4.43848 1.2648C4.43848 1.51055 4.63508 1.70715 4.88083 1.70715C5.12658 1.70715 5.32318 1.51055 5.32318 1.2648C5.32318 1.05509 5.49357 0.884702 5.70327 0.884702H13.1413C13.351 0.884702 13.5214 1.05509 13.5214 1.2648V11.9369C13.5214 12.1466 13.351 12.317 13.1413 12.317C12.8956 12.317 12.699 12.5136 12.699 12.7594C12.699 13.0051 12.8956 13.2017 13.1413 13.2017C13.8393 13.2017 14.4061 12.6349 14.4061 11.9369V1.2648C14.4061 0.566865 13.8393 0 13.1413 0Z",
  fill: "currentColor"
});

var SvgCopy = function SvgCopy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 13,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCopy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/copy.24af5de5.svg";
export { ForwardRef as ReactComponent };